import {useRef, useEffect} from "react";
import SwiperCore, {Pagination, Navigation, Thumbs} from "swiper";
import {PaginationOptions} from "swiper/types";
import {SlideProps} from "@FRAMEWORK/ui/types/d";
import {ZoomSlider} from "@COMPONENTS/style/slide";

interface Props extends SlideProps {
	thumbs: SwiperCore;
}

const ZoomSlide = ({thumbs, children}: Props) => {
	const swiperRef = useRef<SwiperCore>(null);
	const PaginationParams: PaginationOptions = {
		type: "fraction",
		formatFractionCurrent(number) {
			if (number < 10) {
				return `0${number}`;
			} else {
				return number;
			}
		},
		formatFractionTotal(number) {
			if (number < 10) {
				return `0${number}`;
			} else {
				return number;
			}
		},
	};
	useEffect(() => {
		if (swiperRef.current?.slides.length > 0) {
			swiperRef.current.slideTo(1, 0, false);
		}
	}, [swiperRef.current?.slides]);
	return (
		<ZoomSlider
			loop={true}
			navigation={true}
			pagination={PaginationParams}
			thumbs={{swiper: thumbs}}
			modules={[Pagination, Navigation, Thumbs]}
			initialSlide={0}
			onBeforeInit={swiper => {
				swiperRef.current = swiper;
			}}
		>
			{children}
		</ZoomSlider>
	);
};

export default ZoomSlide;
